import { useReturnBearLocations } from "@redotech/redo-customer-portal-shared/hooks/useShipmentLocations/use-shipment-locations";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { LoadingRedoAnimation } from "@redotech/redo-web/loading-redo-animation";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";
import { InteractiveMap } from "../in-store-locations";

const ReturnBearLocationsModal = memo(function ReturnBearLocationsModal({
  draftReturnId,
  returnId,
}: {
  draftReturnId?: string;
  returnId?: string;
}) {
  const { t } = useTranslation();
  const { locationsLoad } = useReturnBearLocations(draftReturnId, returnId);

  if (locationsLoad.pending) {
    return <LoadingRedoAnimation />;
  }

  if (locationsLoad.error) {
    return (
      <Text textColor="error">{t("Error loading Return Bear locations")}</Text>
    );
  }

  if (!locationsLoad.value) {
    return null;
  }

  return <InteractiveMap locations={locationsLoad.value} />;
});

export const ReturnBearLocationsButton = memo(
  function ReturnBearLocationsButton({
    draftReturnId,
    returnId,
    autoOpen = false,
  }: {
    draftReturnId?: string;
    returnId?: string;
    autoOpen?: boolean;
  }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(autoOpen);
    return (
      <Flex>
        <RedoButton
          hierarchy="secondary"
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(true);
          }}
          text={t("See available locations")}
        />
        <RedoModal
          isOpen={isOpen}
          onModalCloseRequested={() => setIsOpen(false)}
          title={t("Find Return Bear drop-off locations")}
        >
          <ReturnBearLocationsModal
            draftReturnId={draftReturnId}
            returnId={returnId}
          />
        </RedoModal>
      </Flex>
    );
  },
);
